export enum CallType {
  Inbound,
  Outbound,
}

export enum CallTypeClass {
  'skin-teritary',
  'skin-primary',
}
